import Api from 'services/Api'

export const clcApi = new Api({
  baseUrl: `${process.env.REACT_APP_CLC_API_URL}/v1`,
  includeBearer: true
})
